<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/5chap1#chap1">Foreword</a></p>
<p class="toc1"><a href="#/6chap2#chap2">Preface</a></p>
<p class="toc1"><a href="#/7chap3#chap3">1. Whistles and Shaving Bristles</a></p>
<p class="toc1"><a href="#/8chap4#chap4">2. Pierce Arrow</a></p>
<p class="toc1"><a href="#/9chap5#chap5">3. Orphans in Uniform</a></p>
<p class="toc1"><a href="#/10chap6#chap6">4. Visiting Mrs. Murphy</a></p>
<p class="toc1"><a href="#/11chap7#chap7">5. Mister Chairman</a></p>
<p class="toc1"><a href="#/12chap8#chap8">6. Touch System</a></p>
<p class="toc1"><a href="#/13chap9#chap9">7. Skipping Through School</a></p>
<p class="toc1"><a href="#/14chap10#chap10">8. Kissing Kin</a></p>
<p class="toc1"><a href="#/15chap11#chap11">9. Chinese Cooking</a></p>
<p class="toc1"><a href="#/16chap12#chap12">10. Motion Study Tonsils</a></p>
<p class="toc1"><a href="#/17chap13#chap13">11. Nantucket</a></p>
<p class="toc1"><a href="#/18chap14#chap14">12. The <i>Rena</i></a></p>
<p class="toc1"><a href="#/19chap15#chap15">13. Have You Seen the Latest Model?</a></p>
<p class="toc1"><a href="#/20chap16#chap16">14. Flash Powder and Funerals</a></p>
<p class="toc1"><a href="#/21chap17#chap17">15. Gilbreths and Company</a></p>
<p class="toc1"><a href="#/22chap18#chap18">16. Over the Hill</a></p>
<p class="toc1"><a href="#/23chap19#chap19">17. Four Wheels, No Brakes</a></p>
<p class="toc1"><a href="#/24chap20#chap20">18. Motorcycle Mac</a></p>
<p class="toc1"><a href="#/25chap21#chap21">19. The Party Who Called You …</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/26biography#biography">A Biography of Frank B. Gilbreth Jr. and Ernestine Gilbreth Carey</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-TOC.vue?c845f7a8